import api, {apiSetup} from '../api';

apiSetup();

export class RoutesService {
    BASE_URL = '/routes/all';

    get() {
        return api.get(this.BASE_URL);
    }
}
